module.exports = __webpack_public_path__ + "static/media/Slide7.e11d4ef0.png";